<template>
  <div v-loading="loading" class="startflow" element-loading-text="数据处理中...">
    <div class="processHeader">
      <span class="title">{{ userInfo.name }} 发起流程</span>
      <div class="rightBtn">
        <el-button v-if="isShowResartBtn" v-preventReClick size="small" type="primary"
          @click="restart">
          重新发起
        </el-button>
        <el-button v-if="!isShowResartBtn" v-preventReClick size="small" type="primary"
          @click="submitProcess">
          提交并发起流程
        </el-button>
        <el-button size="small" @click="reback">取 消</el-button>
      </div>
    </div>
    <div class="content">
      <div class="formList">
        <div class="name"> 基本信息 </div>
        <!-- <div v-if="flowDescribe">流程描述：{{ flowDescribe }}</div> -->
        <!-- 动态表单 -->
        <form-create v-if="isShowDynamicForm" v-model="dynamicFormData" :rule="dynamicFormRule"
          :option="dynamicFormOptions" @submit="onSubmit" />
        <!-- 代码中定义的表单组件 -->
        <component :is="businessForm" v-if="!isShowDynamicForm" ref="businessForm" :flow-definition-id="flowDefinitionId"
          @tableshow="tableshow" @change_showStartButtons="change_showStartButtons" />
        <!-- 流程的文件列表 -->
        <flowFileEditor ref="flowFileEditor" :files="floderData" />
        <div v-if="showBotton" class="check">
          <el-button size="small" type="primary" @click="queryApproveNodes"> 查询处理人设置 </el-button>
          <el-button size="small" plain type="primary" style="margin-left:10px" @click="queryFlowImage">
            查询流程图
          </el-button>
        </div>
      </div>
      <!-- 处理人 -->
      <div v-show="isShowFlowUsers" class="nextProcess">
        <flowNodesEditor ref="flowNodesEditor" :flow-key="flowKey" :flow-definition-id="flowDefinitionId"
          :flow-version-id="flowVersionId" />
      </div>
      <!-- 流程图 -->
      <div v-show="isShowFlowImage" class="nextProcess">
        <flowImage ref="flowImage" :read-only="true" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import formCreate from "@form-create/element-ui";
import flowService from "@/CommonDP/service/flow-service";
import flowNodesEditor from "./components/flowNodesEditor.vue";
import flowImage from "./components/flowImage.vue";
import commonFlowForm from "./modules/commonFlowForm.vue";
import globalParams from "@/CommonDP/utils/globalParams";
import flowFileEditor from "./components/flowFileEditor";
import { FlowStatusEnum } from "./FlowConstants";
import approveService from "@/CommonDP/service/approve-service";
export default {
  components: { flowImage, flowNodesEditor, flowFileEditor, commonFlowForm },
  data() {
    return {
      loading: false,
      flowStatus: null, // 流程状态：0是已驳回，1是已审批，2是审批中，3是已撤回
      isShowDynamicForm: false, // 是否是自定义表单
      dynamicFormId: "",
      dynamicFormData: null,
      dynamicFormRule: "",
      dynamicFormOptions: "",
      isShowFlowUsers: false,
      isShowFlowImage: false,
      businessForm: "", // 表单组件
      showStartButtons: false,
      hasQueryUsers: false,
      isRestart: true,
      showBotton: true,
      stageId: "",
      childId: "",
      floderData: []
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      floderObj: (state) => state.uploaderLocal.floderObj,
      enterpriseId: (state) => state.enterprise.enterpriseId,
      routerParams: (state) => state.projectMg.routerParams,
      userInfo: (state) => state.user.userInfo
    }),
    flowKey() {
      return this.routerParams.flowKey;
    },
    flowDefinitionId() {
      return this.routerParams.flowDefinitionId;
    },
    flowVersionId() {
      return this.routerParams.currentVersionId;
    },
    flowDescribe() {
      return decodeURI(this.routerParams.flowDescribe);
    },

    isShowResartBtn() {
      return this.routerParams.status === FlowStatusEnum.REJECTED || this.routerParams.status === FlowStatusEnum.WITHDRAW;
    }
  },

  async mounted() {
    if (!this.$route.query.isFlowRestart) {
      // 有值属于再发起
      // Cad发起打开
      const flowKey = this.$route.query.flowKey;
      const enterpriseId = this.$route.query.enterpriseId;
      const { data } = await flowService.queryFlowByFlowKey(flowKey, enterpriseId);
      const params = {
        status: this.$route.query.status ? this.$route.query.status : null,
        prjId: this.$route.query.prjId,
        enterpriseId: this.$route.query.enterpriseId,
        flowDefinitionId: this.$route.query.flowDefinitionId || data.flowDefinitionId,
        flowKey: this.$route.query.flowKey,
        name: this.$route.query.flowName,
        clientType: 1,
        stageId: this.$route.query.stageId || "",
        childId: this.$route.query.childId || "",
        startFlowMode: Number(this.$route.query.startFlowMode)
      };
      this.stageId = this.$route.query.stageId || "";
      this.childId = this.$route.query.childId || "";
      this.$store.dispatch("setRouterParams", params);
    }
    this.getInit();
  },
  methods: {
    tableshow(val) {
      this.floderData = val;
    },
    async getInit() {
      console.log("当前流程数据：", this.routerParams);
      this.showStartButtons = false;
      this.dynamicFormId = this.$route.query.formId;
      this.isRestart = !!this.$route.query.restart;
      this.flowStatus = this.routerParams.status;
      this.isShowDynamicForm = false;
      this.hasQueryUsers = false;
      this.mapComponentName();
      if (!this.businessForm) {
        // 如果没有加载到自定义表单，则尝试加载动态表单
        await this.queryDynamicForm();
      }
      if (!this.flowStatus) {
        if (this.routerParams.flowKey === "tz" || this.routerParams.flowKey === "check") {
          this.$nextTick(() => {
            console.log(JSON.parse(this.$route.query.list));
            const list = JSON.parse(this.$route.query.list || []);
            list.forEach((ele) => {
              ele.fileType = Number(ele.fileType);
            });
            this.$refs.flowFileEditor.setFileList(list || []);
            this.$refs.businessForm.setSpecId(this.$route.query.major || "");
            if (this.routerParams.startFlowMode === 1) {
              if (this.routerParams.flowKey === "tz") {
                this.$refs.businessForm.setFileLocation(this.$route.query.lastfolderId || "");
              } else {
                this.queryDefaultDirectory();
              }
            }
          });
        } else if (this.routerParams.flowKey === "publish") {
          this.$nextTick(() => {
            const list = JSON.parse(this.$route.query.list || []);
            const rebuildList = [];
            list.forEach((ele) => {
              ele.fileType = Number(ele.fileType);
              this.$set(ele, 'parentFileId', '');
              rebuildList.push(ele);
              ele.childFileList.forEach((eleChild) => {
                eleChild.fileType = Number(eleChild.fileType);
                this.$set(eleChild, 'parentFileId', ele.fileId);
                rebuildList.push(eleChild);
              });
            });
            this.$refs.flowFileEditor.setFileList(rebuildList || []);
            this.$refs.businessForm.setSpecId(this.$route.query.major || "");
            if (this.routerParams.startFlowMode === 1) {
              this.queryDefaultDirectory();
            }
          });
        }
      }
      if (this.flowStatus === FlowStatusEnum.REJECTED || this.flowStatus === FlowStatusEnum.WITHDRAW) {
        this.queryFormData();
      }
    },
    async queryDefaultDirectory() {
      const prjId = this.$route.query.prjId;
      const { data } = await approveService.queryByOldld('1630984405554', prjId);
      const obj = {
        folderId: data
      };
      this.$refs.businessForm.setFileLocation(obj || {});
    },
    mapComponentName() {
      if (!this.routerParams.flowKey) {
        this.businessForm = commonFlowForm;
        return;
      }
      // 这里默认 flowKey 与 formKey 相同
      const formKey = `flow.form.` + this.routerParams.flowKey;
      const form = globalParams.get(formKey, null);
      console.log("查找流程表单 ", formKey, form);
      if (form) {
        this.businessForm = form;
      } else {
        this.businessForm = commonFlowForm;
        return;
      }
    },
    // 查询自动表单
    async queryDynamicForm() {
      if (!this.dynamicFormId) {
        return;
      }
      this.loading = true;
      try {
        const res = await flowService.formCreateQuery(this.dynamicFormId);
        this.dynamicFormOptions = formCreate.parseJson(JSON.stringify(res.data[0].operation) || "");
        this.dynamicFormRule = formCreate.parseJson(JSON.stringify(res.data[0].rule) || "");
        this.isShowDynamicForm = true;
      } finally {
        this.loading = false;
      }
    },
    // 查询业务表单
    async queryFormData() {
      this.loading = true;
      try {
        const res = await flowService.getBusinessForm(this.routerParams.flowInstanceId);
        // 为了兼容做以下处理，最新的应该是 res.data.businessData
        let formData = res.data.object.param ? { ...res.data.object, ...JSON.parse(res.data.object.param) } : '';
        if (!formData) {
          formData = res.data.object;
        }
        if (!formData) {
          formData = res.data.businessData;
        }
        if (this.isShowDynamicForm) {
          this.$refs.flowFileEditor.setFileList(res.data.fileInfoList || []);
          await this.$nextTick();
          this.dynamicFormData.coverValue(formData);
        } else {
          this.$refs.businessForm.setFormData(formData || {});
          // revit查看流程时，fileInfoList里吧uploadType等于0的放到表单模型里
          if (this.routerParams.clientType === 2 && this.routerParams.startFlowMode === 1) {
            if (this.routerParams.flowKey === "tz" || this.routerParams.flowKey === "check") {
              // 模型列表
              const modelList = res.data.fileInfoList.filter((ele) => ele.uploadType === 0);
              this.$refs.businessForm.setModelList(modelList);

              const fileInfoList = res.data.fileInfoList.filter((ele) => ele.uploadType !== 0);
              this.$refs.flowFileEditor.setFileList(fileInfoList || []);
            }
          } else {
            this.$refs.flowFileEditor.setFileList(res.data.fileInfoList || []);
          }
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    // 表单的提交
    onSubmit() {
      console.error("未实现 onSubmit");
    },
    // 提交
    async submitProcess() {
      if (!this.hasQueryUsers) {
        await this.queryApproveNodes();
      }
      this.showStartButtons = false;
      this.loading = true;
      try {
        // 流程发起时 校验下除第一个节点的其他节点有无审批人
        const result = this.$refs.flowNodesEditor.checkNodeList_AssigneeList();
        if (!result.flag) {
          try {
            await this.$confirm(`第 ${result.nodeIndexes} 个流程节点: ${result.nodeNames} 无审批人，继续发起流程吗？`);
          } catch (error) {
            console.log(error);
            return;
          }
        }
        const res = await flowService.addFlow(this.makeSubmitParam());
        this.loading = false;
        if (res.data && res.data.code && res.data.code === "E.FLOW.0005") {
          this.showStartButtons = true;
          const nodeDefinitionId = res.data.nodeDefinitionId || "";
          this.$refs.flowNodesEditor.selectApplicant(nodeDefinitionId);
        } else {
          this.$success("发起流程成功");
          this.reback();
        }
      } catch (error) {
        if (this.routerParams.flowKey === "tz") this.$refs.businessForm.setAcceptSpecialty(this.makeSubmitParam()); // 流程发起报错时，提资流程的接收专业选项

        console.error(error);
        console.debug("流程发起失败", error);
        this.showStartButtons = true;
      } finally {
        this.loading = false;
      }
    },
    // 流程再发起
    async restart() {
      if (!this.hasQueryUsers) {
        await this.queryApproveNodes();
      }
      this.loading = true;
      try {
        this.showStartButtons = false;

        // 流程发起时 校验下除第一个节点的其他节点有无审批人
        const result = this.$refs.flowNodesEditor.checkNodeList_AssigneeList();
        if (!result.flag) {
          try {
            await this.$confirm(`第 ${result.nodeIndexes} 个流程节点: ${result.nodeNames} 无审批人，继续发起流程吗？`);
          } catch (error) {
            console.log(error);
            return;
          }
        }
        const res = await flowService.restart(this.makeSubmitParam());
        this.loading = false;
        if (res.data && res.data.code && res.data.code === "E.FLOW.0005") {
          this.showStartButtons = true;
          const nodeDefinitionId = res.data.nodeDefinitionId || "";
          this.$refs.flowNodesEditor.selectApplicant(nodeDefinitionId);
        } else {
          this.$success("重新发起流程成功");
          this.reback();
        }
      } catch (error) {
        if (this.routerParams.flowKey === "tz") this.$refs.businessForm.setAcceptSpecialty(this.makeSubmitParam()); // 流程发起报错时，提资流程的接收专业选项

        console.error(error);
        console.debug("重新发起失败", error);
        this.showStartButtons = true;
      } finally {
        this.loading = false;
      }
    },
    makeSubmitParam() {
      if (this.isShowDynamicForm) {
        const json = this.dynamicFormData.form;
        if (json) {
          json.childId = this.childId;
          json.stageId = this.stageId;
        }
        return {
          flowInstanceId: this.routerParams.flowInstanceId || "",
          flowDefinitionId: this.routerParams.flowDefinitionId,
          flowKey: this.routerParams.flowKey,
          prjId: this.routerParams.prjId || this.prjInfo.prjId,
          enterpriseId: this.routerParams.enterpriseId || this.enterpriseId,
          flowNodeDtoList: this.$refs.flowNodesEditor.getFlowNodeWithAddedUsers(),
          ccUserIdList: this.$refs.flowNodesEditor.expose_getCCUserIdList(),
          childId: this.childId,
          stageId: this.stageId,
          json: json
        };
      } else {
        const json = this.$refs.businessForm.getFormData();
        if (json.acceptSpecialty) {
          json.acceptSpecialty = json.acceptSpecialty.toString();
        }
        json.fileInfoList = this.$refs.flowFileEditor.getFileList();
        // revit发起流程时，把uploadType等于0的模型放fileInfoList到里
        if (this.routerParams.flowKey === "tz" || this.routerParams.flowKey === "check") {
          // 模型列表
          const modelList = this.$refs.businessForm.getModelList();
          modelList.forEach((ele) => {
            json.fileInfoList.push(ele);
          });
        }
        if (json) {
          json.childId = this.childId;
          json.stageId = this.stageId;
        }
        return {
          flowInstanceId: this.routerParams.flowInstanceId || "",
          flowDefinitionId: this.routerParams.flowDefinitionId,
          flowKey: this.routerParams.flowKey,
          prjId: this.routerParams.prjId || this.prjInfo.prjId,
          enterpriseId: this.routerParams.enterpriseId || this.enterpriseId,
          flowNodeDtoList: this.$refs.flowNodesEditor.getFlowNodeWithAddedUsers(),
          ccUserIdList: this.$refs.flowNodesEditor.expose_getCCUserIdList(),
          clientType: 1, //  发起流程来源;0web;1cad;2revit;默认0
          startFlowMode: this.routerParams.startFlowMode, // 发起流程方式;0审批入口;1右键;默认0
          childId: this.childId,
          stageId: this.stageId,
          json: json
        };
      }
    },
    // 查询处理人设置
    async queryApproveNodes() {
      const success = await this.validateBeforeQueryNodes();
      if (success) {
        this.isShowFlowImage = false;
        this.isShowFlowUsers = true;
        await this.queryFlowNodes();
        this.hasQueryUsers = true;
        return Promise.resolve();
      } else {
        return Promise.reject();
      }
    },

    async validateBeforeQueryNodes() {
      if (this.isShowDynamicForm) {
        try {
          return await this.dynamicFormData.validate();
        } catch (e) {
          console.debug("数据验证失败: " + e);
          return false;
        }
      } else {
        return this.$refs.businessForm.validateFormData();
      }
    },

    async queryFlowNodes() {
      const formData = this.isShowDynamicForm ? this.dynamicFormData.form : this.$refs.businessForm.getFormData();
      const prjId = this.routerParams.prjId || this.prjInfo.prjId;
      const useLastestVersion = (!this.flowStatus && this.flowStatus !== FlowStatusEnum.REJECTED) || this.flowStatus === FlowStatusEnum.WITHDRAW;
      const success = await this.$refs.flowNodesEditor.queryFlowNodes(formData, prjId, useLastestVersion);
      if (success) {
        this.showStartButtons = true;
      }
    },
    // 查询流程图
    async queryFlowImage() {
      this.isShowFlowImage = true;
      this.isShowFlowUsers = false;
      await this.$nextTick();
      this.$refs.flowImage.showView(this.routerParams.flowDefinitionId, this.routerParams.flowKey);
    },

    async reback() {
      await CefSharp.BindObjectAsync("cefSharpBrower");
      cefSharpBrower.closeWindow();
    },
    // 切换专业 隐藏发起按钮
    change_showStartButtons() {
      this.showStartButtons = false;
      this.hasQueryUsers = false;
      this.isShowFlowUsers = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.startflow {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .processHeader {
    width: 100%;
    height: 50px;
    padding: 0 20px;
    background: #fff;
    border-bottom: 1px solid #ebefff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .title {
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
    }
  }

  .content {
    width: 100%;
    margin-top: 10px;
    height: calc(100% - 60px);
    overflow-x: hidden;
    overflow-y: auto;

    .formList {
      width: 100%;
      background: #fff;
      padding-left: 20px;
      padding-right: 10px;

      .name {
        box-sizing: border-box;
        height: 45px;
        margin-bottom: 10px;
        font-weight: 700;
        font-size: 16px;
        line-height: 45px;
        color: var(--theme-color);
        border-bottom: 1px solid #ebefff;
      }

      .check {
        height: 45px;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;

      }
    }

    .nextProcess {
      margin-top: 10px;
      width: 100%;
      background: #fff;
    }
  }
}
</style>
